var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0007 2C8.03784 2.00753 4.45326 4.35452 2.86168 7.98377C1.27009 11.613 1.9718 15.8397 4.65073 18.76C6.54389 20.8121 9.20875 21.9793 12.0007 21.9793C14.7927 21.9793 17.4576 20.8121 19.3507 18.76C22.0297 15.8397 22.7314 11.613 21.1398 7.98377C19.5482 4.35452 15.9636 2.00753 12.0007 2ZM12.0007 20C9.9292 19.9969 7.93965 19.1903 6.45074 17.75C7.37527 15.4993 9.56754 14.0298 12.0007 14.0298C14.4339 14.0298 16.6262 15.4993 17.5507 17.75C16.0618 19.1903 14.0723 19.9969 12.0007 20ZM10.0007 10C10.0007 8.89543 10.8962 8 12.0007 8C13.1053 8 14.0007 8.89543 14.0007 10C14.0007 11.1046 13.1053 12 12.0007 12C10.8962 12 10.0007 11.1046 10.0007 10ZM18.9107 16C18.0173 14.4718 16.6421 13.283 15.0007 12.62C16.419 11.0119 16.317 8.57152 14.7695 7.08736C13.222 5.60321 10.7795 5.60321 9.232 7.08736C7.68451 8.57152 7.58251 11.0119 9.00074 12.62C7.35933 13.283 5.9842 14.4718 5.09074 16C4.37868 14.7871 4.00246 13.4065 4.00074 12C4.00074 7.58172 7.58246 4 12.0007 4C16.419 4 20.0007 7.58172 20.0007 12C19.999 13.4065 19.6228 14.7871 18.9107 16Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default ForwardRef;